
<template>
	<footer class="mint-tabbar is-fixed">
		<div class="mint-tab-item" v-for="(i, index) in tabList[0]">
			<router-link :to="i.path">
				<span class="mint-tab-item-icon"><span>{{ index == 0 ? i.name.slice(2, 3) : i.name.slice(0, 1) }}</span></span>
				<span class="mint-tab-item-label">{{ i.name }}</span>
			</router-link>
		</div>
		<div class="mint-tab-item" @click="showMore">
			<a>
				<span class="mint-tab-item-icon"><span>...</span></span>
				<span class="mint-tab-item-label">更多</span>
			</a>
		</div>

		<div class="confirm" v-show="showConfirm" @click="hiddenMore">
			<div class="footer-confirm">
			<div class="mint-tabbar" v-for="(i, index) in tabList">
				<div class="mint-tab-item" v-for="j in tabList[index]">
					<router-link :to="j.path">
						<span class="mint-tab-item-icon"><img slot="icon" :src="require('@/assets/'+j.imgSrc)"></span>
						<span class="mint-tab-item-label">{{ j.name }}</span>
					</router-link>
				</div>
			</div>
			<div class="out"></div>
			<div class="in"></div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'Footer',
	data() {
		return {
			showConfirm: !1,
			tabList: tabList
		}
	},
	methods: {
		showMore() {
			this.showConfirm = !0;
		},
		hiddenMore() {
			this.showConfirm = !1;
		}
	}
}


var tabList = [[{
	id: 1,
	imgSrc: "统.png",
	name: "六合统计",
	path: "/zxcount/liuhe"
}, {
	id: 2,
	imgSrc: "属.png",
	name: "属性参照",
	path: "/zxcount/attribute"
}, {
	id: 3,
	imgSrc: "特.png",
	name: "特码历史",
	path: "/zxcount/specialcode"
}, {
	id: 4,
	imgSrc: "正.png",
	name: "正码历史",
	path: "/zxcount/positivecode"
}], [{
	id: 5,
	imgSrc: "尾.png",
	name: "尾数大小",
	path: "/zxcount/wstable"
}, {
	id: 6,
	imgSrc: "生.png",
	name: "生肖特码",
	path: "/zxcount/sxpiechart2"
}, {
	id: 7,
	imgSrc: "肖.png",
	name: "生肖正码",
	path: "/zxcount/sxpiechart1"
}, {
	id: 8,
	imgSrc: "色.png",
	name: "波色特码",
	path: "/zxcount/bspiechart2"
}], [{
	id: 9,
	imgSrc: "波.png",
	name: "波色正码",
	path: "/zxcount/bspiechart1"
}, {
	id: 10,
	imgSrc: "特.png",
	name: "特码两面",
	path: "/zxcount/barchart2"
}, {
	id: 11,
	imgSrc: "尾.png",
	name: "特码尾数",
	path: "/zxcount/wspiechart2"
}, {
	id: 12,
	imgSrc: "数.png",
	name: "正码尾数",
	path: "/zxcount/wspiechart1"
}], [{
	id: 13,
	imgSrc: "分.png",
	name: "正码总分",
	path: "/zxcount/barchart1"
}, {
	id: 14,
	imgSrc: "段.png",
	name: "号码波段",
	path: "/zxcount/hmpiechart"
}, {
	id: 15,
	imgSrc: "禽.png",
	name: "家禽野兽",
	path: "/zxcount/jqystable"
}, {
	id: 16,
	imgSrc: "码.png",
	name: "连码走势",
	path: "/zxcount/lmtable"
}], [{
	id: 17,
	imgSrc: "连.png",
	name: "连肖走势",
	path: "/zxcount/lxtable"
}]]

</script>

<style lang="less">
@media screen and (min-width: 769px) {
	.mint-tabbar,.confirm {
		width: 480Px;
		margin: 0 auto
	}

}

.mint-tabbar .mint-tab-item-icon {
	display: block;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background: #07c160;
	color: #fff;
	font-size: 24px;
	text-align: center;
	margin-bottom: 12px
}

a {
    background-color: transparent;
}

a {
    text-decoration: none;
}

.mint-tabbar .mint-tab-item-label {
	font-size: 16px;
	color: #333
}

.confirm {
    position: fixed;
    top: 90%;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.3)
}

.mint-tabbar .confirm .footer-confirm {
    position: absolute;
    bottom: 7rem;
    width: calc(100% - .48rem);
    left: .24rem;
    background: #fff;
    box-sizing: border-box;
    border-radius: .08rem;
    padding-top: .2rem
}

.mint-tabbar .confirm .footer-confirm .in,.mint-tabbar .confirm .footer-confirm .out {
    position: absolute;
    width: 0px;
    height: 0px;
}

.mint-tabbar .confirm .footer-confirm .out {
    border: 1rem solid transparent;
    border-top-color: #fff;
    bottom: -2.8rem;
    right: 2.4rem
}

.mint-tabbar .confirm .footer-confirm .in {
    border: 1rem solid transparent;
    border-top-color: #fff;
    bottom: -2.8rem;
    right: 2.42rem
}

.mint-tabbar .confirm .footer-confirm .mint-tab-item-icon,.mint-tabbar .confirm .footer-confirm .mint-tabbar {
    background: none;
    box-shadow: none;
    position: static
}

.mint-tabbar .confirm .footer-confirm .mint-tab-item {
    max-width: 25%
}

.mint-tabbar .confirm .footer-confirm .mint-tab-item .mint-tab-item-icon {
    width: 40px;
    height: 40px;
}

.mint-tabbar .confirm .footer-confirm .mint-tab-item .mint-tab-item-label {
    line-height: .34rem
}

.mint-tabbar .mint-tab-item a {
    text-decoration: none;
    display: block;
    padding: .12rem 0;
}

.mint-tabbar .mint-tab-item a.router-link-active {
    background: #efefef;
}

.mint-tabbar .mint-tab-item {
    display: block;
    padding: 0;
    flex: 1;
    text-decoration: none;
}
</style>